import { HTTP } from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = '';

const salesReturnStore = {
    namespaced: true,
    state: {
        totalItem: 0,
        q: {
            tableNeedQuery: tableName,
            isOuterJoin: false,
            searchCriteria: "",
            orderBy: "",
            take: 1000000,
            skip: 0
        },
        currentSelectedPage: 0,
    },
    actions: {
        getSRList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/sr/getsrlist', param).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getInvoiceRef({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/sr/GetInvoiceReference', {itemNum:param.itemNum, entNum: param.entNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        copySODetails({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/copyso', { SONum: param.SONum, entNum: param.entNum, loc: param.loc }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getSRByTxNo({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/sr/getsrbytxnum', { txNum: param.txNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getDN({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/getDN', { txNum: param.txNum, locCode: param.locCode, refNum: param.refNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getEventCodeList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/SO/GetEventList').then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getRefSOList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/getrefsolist', { entNum: param.entNum, itemNum: param.itemNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        saveSalesReturn({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/sr/save', JSON.stringify({ header: param.header, details: param.details, misc: param.misc })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        deleteSR({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/sr/delete', JSON.stringify({ txNum: param.txNum })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getExpiryDateList({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/getexpirydatelist', JSON.stringify({ itemNum: param.itemNum, warehouseLoc: param.warehouseLoc, dateTx: param.dateTx })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getMainStockBalance({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/getmainstockbalance', JSON.stringify({ itemNumber: param.itemNum, DateExpire: param.expDate })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getCustomerDefault({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getcustomerdefault', JSON.stringify({ entityNumber: param.entityNum })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getCustomerLocationModel({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/getcustomerlocationmodel', JSON.stringify({ entNum: param.entityNum, entLoc: param.entLoc, lang: param.lang })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        calBaseCurAmt({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/calbasecuramt', JSON.stringify({ amtForeign: param.AmountForeign, curCode: param.CurCode, exRate: param.ExRate })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        exportFile({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/mm/export', state.q, { responseType: 'blob' }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        approveSR({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/sr/approve', { txNum: param.txNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        rejectSR({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/sr/reject', { txNum: param.txNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getCustReqAprv({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/CustReqAprv').then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getPickingList({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/GetPickingList', param).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        updateInvoiceDate({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/ChangeInvoiceDate', param).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        printSR({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/sr/printsr', { txNum: param.txNum, isPosted: param.isPosted,rptID: param.rptID }, { responseType: 'blob' }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        invRpt({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/invrpt').then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getSalesAnalysisPivotList({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/SalesAnalysisPivotList').then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
    }
};
export default salesReturnStore;